import {Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {FormBuilder, FormGroup} from "@angular/forms";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {GlobalSearchPanelComponent} from "@components/globalSearch/panel/panel.component";
import {GlobalSearchService} from "@core/globalSearch/globalSearch.service";
import {NavigationExtras, Router} from "@angular/router";

declare function require(url: string);

enum SEARCH_STATUS {
  START = "start",
  IN_PROGRESS = "inprogress",
  DONE = 'done'
}

@Component({
  selector: 'global-search',
  templateUrl: './globalSearch.component.html',
  styleUrls: ['./globalSearch.component.less'],
  animations: [
    trigger('headerActive', [
      state('*', style({
        left: '50%',
        opacity: 1
      })),
      state('void', style({
        opacity: 0,
      })),
      transition('* => void', animate('250ms ease-in-out')),
    ]),
    trigger('isActive', [
      state('true', style({
        left: '50%',
        transform: 'translateX(-50%)',
      })),
      state('false', style({
        transform: 'translateX(100px)'
      })),
      state('void', style({
        left: "50%",
        transform: 'translateX(250px)',
      })),
      transition('void => true', animate('250ms ease-in-out')),
    ]),
    trigger('searchPanelAnimation', [
      state('true', style({
        transform: 'translate(-50%, 0)',
      })),
      state('void', style({
        transform: "translate(-50%, -250px)",
      })),
      transition('void <=> true', animate('250ms ease-in-out')),
    ])
  ]
})

export class GlobalSearchComponent implements OnInit {
  public isSearchToggle: boolean = false;
  public isClosing = false;

  public form: FormGroup;
  public results: any[] = [];
  public resultsCount: number = undefined;
  public searchStatus: SEARCH_STATUS = SEARCH_STATUS.START;

  @ViewChild("searchInput", {read: ElementRef})
  searchInputElement: ElementRef;

  @ViewChild('globalSearchPanel') globalSearchPanel: GlobalSearchPanelComponent;

  constructor(private fb: FormBuilder, private router: Router,
              private globalSearchService: GlobalSearchService) {
  }

  ngOnInit() {
    this.form = this.fb.group({
      searchText: ""
    });

    this.form.controls['searchText'].valueChanges.debounceTime(500)
      .subscribe(txt => {
        this.results = [];
        this.resultsCount = undefined;
        if (txt && txt.length > 2) {
          this.searchStatus = SEARCH_STATUS.IN_PROGRESS;
          this.globalSearchService.search(txt, 5)
            .then(results => {
              this.results = results.results;
              this.resultsCount = results.count;
              this.searchStatus = SEARCH_STATUS.DONE;
            });
        } else {
          this.searchStatus = SEARCH_STATUS.START;
        }
      });
  }

  onKeyup(event) {
    if (event.key === "Enter") {
      this.navigateToGlobalSearchPage();
      // this.openPanel();
    } else if (event.key === "Escape"){
      this.closePanel();
    }
  }

  onClick() {
    this.isClosing = false;
    this.isSearchToggle = true;
    this.searchStatus = SEARCH_STATUS.START;

    // Because the input search box uses ngIf, the input text box is not yet shown.
    // we have to create a timeout to set the focus
    setTimeout(() => this.searchInputElement.nativeElement.focus(), 0);
  }

  navigateToGlobalSearchPage() {
    let navExtra: NavigationExtras = {
      queryParams: {searchText: this.form.controls['searchText'].value}
    };

    this.router.navigate(['search'], navExtra)
      .then(()=>{
        // close the search Panel
        this.isSearchToggle = false;
        this.form.controls['searchText'].setValue('');
      });
  }

  openPanel() {
    this.globalSearchPanel.searchText = this.form.controls['searchText'].value;
    this.globalSearchPanel.search(this.globalSearchPanel.searchText);
    this.globalSearchPanel.open = true;
    this.isSearchToggle = false;
    this.form.controls['searchText'].setValue('');
  }

  closePanel() {
    this.isClosing = true;

    // We are delaying the search toggle to get the animation.
    setTimeout(() => {
      this.isSearchToggle = false;
      this.form.controls['searchText'].setValue('');
    }, 250);
  }

  getIcon(thing: any) {
    switch (thing.type.toUpperCase()) {
      case "TRASH":
        return "kng-icon-trash";
      case "RECYCLE":
        return "kng-icon-recycle";
      case "RESTROOM_MALE":
        return "kng-icon-restroom-men";
      case "RESTROOM_FEMALE":
        return "kng-icon-restroom-women";
      default:
        return "kng-icon-map";
    }
  }

  onRowClick(item) {
    this.closePanel();
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/globalSearch/globalSearch.component.ts